import { Button, FormControl, FormField, FormItem, FormLabel, Input } from '@kalos/ui';

import { usePropertySearchFormContext } from './utils';

/**
 * The search fields. `inSheet` renders them for the phone filter sheet: one column, no form of
 * their own (the sheet is the form) and no Reset (the sheet has Reset filters).
 */
const PropertySearchForm = ({ inSheet = false }: { inSheet?: boolean }) => {
  const form = usePropertySearchFormContext();
  const Fields = inSheet ? 'div' : 'form';
  return (
    // intentionally ignored as values are used as they are typed in
    <Fields
      className={
        inSheet
          ? 'flex flex-col gap-4'
          : 'grid grid-cols-2 place-content-center gap-x-4 gap-y-3 md:grid-cols-3 lg:grid-cols-[repeat(4,minmax(0,1fr))_5rem]'
      }
      {...(inSheet ? {} : { onSubmit: form.handleSubmit(console.log) })}
    >
      <FormField
        control={form.control}
        name="address"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Address</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="subdivision"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Subdivision</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="city"
        render={({ field }) => (
          <FormItem>
            <FormLabel>City</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="zip"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Zip Code</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      {!inSheet && (
        <Button
          type="reset"
          variant="outline"
          className="mt-auto max-w-max"
          onClick={() => form.reset()}
        >
          Reset
        </Button>
      )}
    </Fields>
  );
};

export default PropertySearchForm;
